import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.5 14.375V17.5h3.125l9.217-9.217-3.125-3.125L2.5 14.375zm14.758-8.508a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z" fill="#54585D" /></svg>);